import { useState, useEffect, useContext } from "react";

// react-router components
import { useLocation, Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

// HG Pro components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";

// HG Pro examples
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";
import { useNavigate } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// HG Pro context
import {
  useSoftUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
  setOpenShiftLog
} from "context";

import swal from 'sweetalert2';
import AuthContext from "context/AuthContext";
import refreshAccessToken from 'adminRefresToken';
import getCSRFToken from 'csrftoken';
import { useAuth } from 'context/AuthContext';

import {
  setselectedPropertyId,
} from "context";


// Images
import team2 from "assets/images/team-2.jpg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";

function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, openShiftLog } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const location = useLocation();
  const route = location.pathname.split("/").filter(Boolean);
  const fullPath = location.pathname;
  const {logout, isSuperAdmin, isAdmin, isManager, isStaff, isUser} = useAuth();
  const { pathname } = useLocation();
  const isUnitTab = pathname.includes("unit");
  const navigate = useNavigate();

// Profile menu state
const [profileMenu, setProfileMenu] = useState(null);

const handleProfileMenuOpen = (event) => {
  setProfileMenu(event.currentTarget);
};

const handleProfileMenuClose = () => {
  setProfileMenu(null);
};

const goToProfile = () => {
  handleProfileMenuClose();
  navigate("/profile");
};

const handleLogoutClick = () => {
  handleProfileMenuClose();
  logout();
};


  // const { adminauthTokens, authTokens, staffauthTokens, managerauthTokens } = useContext(AuthContext);

  // const [loading, setIsLoading] = useState(false);

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenShiftLog(dispatch, true);
  const handleConfiguratorOpenSupport = () => setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  // const showAddQueryButton = staffauthTokens || managerauthTokens || isSuperAdmin || isAdmin;

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);

  //   try {
  //     const newAccessToken = await refreshAccessToken(showAddQueryButton?.refresh);
  //     const formData = new FormData();

  //     // //console.log(formData);

  //     const response = await fetch(`https://hgpro.nyc/manager/api/login/workflow`, {
  //       method: 'POST',
  //       headers: {
  //         'X-CSRFToken': getCSRFToken(),
  //         'Authorization': `Bearer ${newAccessToken}`,
  //       },
  //       body: formData,
  //     });

  //     if (response.status === 200) {
  //       swal.fire({
  //         title: "Workflow account created Successfully..",
  //         icon: "success",
  //         toast: true,
  //         timer: 3000,
  //         position: 'bottom-right',
  //         timerProgressBar: true,
  //         showConfirmButton: false,
  //       });
  //       const responseData = await response.json();
  //       // //console.log(responseData)
  //       window.open(responseData.link, '_blank');
  //     } else {
  //       const responseData = await response.json();
  //       // //console.log(responseData);
  //       if (responseData.success === false && responseData.error === "login") {
  //         logoutUser();
  //         // //console.log("User needs to log in. Logging out...");
  //       } else {
  //         // console.error("Error adding request.");
  //         swal.fire({
  //           title: "Error adding request.",
  //           icon: "error",
  //           toast: true,
  //           timer: 3000,
  //           position: 'bottom-right',
  //           timerProgressBar: true,
  //           showConfirmButton: false,
  //         });
  //       }
  //     }
  //   } catch (error) {
  //     // console.error('Error adding request', error);
  //     swal.fire({
  //       icon: 'error',
  //       title: 'Error',
  //       text: 'An error occurred. Please try again later.',
  //       toast: true,
  //       timer: 3000,
  //       position: 'bottom-right',
  //       timerProgressBar: true,
  //       showConfirmButton: false,
  //     });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        image={<img src="https://mediumwallet.nyc/static/assets/media/logos/MEDIUM-Og.png" alt="person" />}
        title={["Login To Medium", ""]}
        // onClick={handleSubmit}
      />
      <NotificationItem
        image={<img src={logoSpotify} alt="person" />}
        title={["New album", "by Travis Scott"]}
        date="1 day"
        onClick={handleCloseMenu}
      />
      <NotificationItem
        color="secondary"
        image={
          <Icon fontSize="small" sx={{ color: ({ palette: { white } }) => white.main }}>
            payment
          </Icon>
        }
        title={["", "Payment successfully completed"]}
        date="2 days"
        onClick={handleCloseMenu}
      />
    </Menu>
  );



  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <SoftBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs
            icon="home"
            title={route.length ? route[route.length - 1] : "Home"}
            route={route}
            fullPath={fullPath}
            light={light}
          />
        </SoftBox>
        {isMini ? null : (
          <SoftBox sx={(theme) => navbarRow(theme, { isMini })}>
            {/* <SoftBox pr={1}>
              <SoftInput
                placeholder="Type here..."
                icon={{ component: "search", direction: "left" }}
              />
            </SoftBox> */}
            <SoftBox color={light ? "white" : "inherit"}>
              {/* <Link onClick={logoutUser}>
                <IconButton sx={navbarIconButton} size="small">
                  <Icon
                    sx={({ palette: { dark, white } }) => ({
                      color: light ? white.main : dark.main,
                    })}
                  >
                    account_circle
                  </Icon>
                  <SoftTypography
                    variant="button"
                    fontWeight="medium"
                    color={light ? "white" : "dark"}
                    onClick={logout}
                  >
                    <a style={{ cursor: "pointer" }}>Logout</a>
                  </SoftTypography>
                </IconButton>
              </Link> */}

              {/* Account Dropdown */}
              <IconButton
                size="small"
                color="inherit"
                sx={navbarIconButton}
                onClick={handleProfileMenuOpen}
                title="Account"
              >
                <Icon
                  sx={({ palette: { dark, white } }) => ({
                    color: light ? white.main : dark.main,
                  })}
                >
                  account_circle
                </Icon>
              </IconButton>

              <Menu
                anchorEl={profileMenu}
                open={Boolean(profileMenu)}
                onClose={handleProfileMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <MenuItem onClick={goToProfile}>
                  <Icon sx={{ mr: 1 }}>person</Icon>
                  Profile
                </MenuItem>

                <MenuItem onClick={handleLogoutClick}>
                  <Icon sx={{ mr: 1 }}>logout</Icon>
                  Logout
                </MenuItem>
              </Menu>

              {(isAdmin || isManager || isStaff) && isUnitTab && (
                <IconButton
                  size="small"
                  color="inherit"
                  sx={navbarIconButton}
                  onClick={handleConfiguratorOpen}
                  title="Shift Notes"
                >
                  <Icon>book</Icon>
                </IconButton>
              )}

              {/* <IconButton
                size="small"
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                <Icon className={light ? "text-white" : "text-dark"}>notifications</Icon>
              </IconButton>
              {renderMenu()} */}
              <IconButton
                size="small"
                color="inherit"
                sx={navbarIconButton}
                onClick={handleMiniSidenav}
              >
                <Icon>menu</Icon>
              </IconButton>
            </SoftBox>
          </SoftBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
